// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d84c319","493":"8f23b0a9"}[chunkId] + ".chunk.js";
};